
























































































































Vue.use require('v-img').default

Currency = require 'models/currency.coffee'

module.exports =
  name: 'sign_up'
  data: ->
    button_hovered: false
    loading: false
    errors: []
    all_currencies: _.orderBy(Currency.default_currencies(), (c) -> c.localizedName())
    new_user:
      email: ''
      password: ''
      password_confirmation: ''
      first_name: ''
      first_day: (if HM.is_russian then 1 else 0)
      default_currency: (if HM.is_russian then 'rub' else 'usd')
      friend_id: Cookies.get('friend_id')
      locale: HM.locale
  mounted: ->
    HM_API.load_currencies().then (payload) =>
      currencies = _.map payload.currencies, (currency) -> new Currency(currency)
      @all_currencies = _.orderBy(currencies, (c) -> c.localizedName())
  methods:
    createUser: ->
      @loading = true
      @errors = []
      HM_API.create_user(@new_user).then (res) =>
        @loading = false
        if res.status == 'failure'
          @errors = res.errors
        if res.status == 'success'
          HM.track_signup(@new_user)
          @$store.dispatch('loginUser',
            form:
              email: @new_user.email
              password: @new_user.password
              remember_me: true
          ).then => @$store.dispatch('redirectUser')
    fillTestUser: ->
      @new_user.first_name = 'Test User'
      @new_user.email = "test_user_#{uuidV4()}@testuser.bee"
      @new_user.password = '111111'
      @new_user.password_confirmation = '111111'

